/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.chart-area[_ngcontent-%COMP%]{margin-right:24px}.chart-area[_ngcontent-%COMP%]  achoo-pie-chart .highcharts-legend .highcharts-legend-item .legend-label .label-text{max-width:108px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.chart-area[_ngcontent-%COMP%]  achoo-pie-chart .highcharts-legend .highcharts-legend-item .legend-label .percentage{text-align:right}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/follower-by-channel/follower-by-channel.component.scss.shim.ngstyle.js.pre-build-optimizer.js